module.exports = "/_next/static/images/delivery_2-cf9a3426386129ba2f55cabc3f17a627.png";